const SCOPE = 'notification-card';

export const PushNotificationCardTestIds = {
  getCardId: id => `${SCOPE}.card-${id}`,
  getStarButtonId: id => `${SCOPE}.star-${id}`,
  getSourceEntityLinkId: id => `${SCOPE}.source-link-${id}`,
  getLearnMoreLinkId: id => `${SCOPE}.learn-more-${id}`,
};
